import { FC } from 'react';

type Props = {
	className?: string;
};

const GlobeIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M10.0001 18.0002C14.4184 18.0002 18.0002 14.4184 18.0002 10.0001C18.0002 5.58176 14.4184 2 10.0001 2C5.58176 2 2 5.58176 2 10.0001C2 14.4184 5.58176 18.0002 10.0001 18.0002Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M6.7998 10.0001C6.7998 14.8001 9.99984 18.0002 9.99984 18.0002C9.99984 18.0002 13.1999 14.8001 13.1999 10.0001C13.1999 5.20003 9.99984 2 9.99984 2C9.99984 2 6.7998 5.20003 6.7998 10.0001Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
			<path
				d='M17.2 12.4H2.7998'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M17.2 7.59998H2.7998'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default GlobeIcon;
